export default function LoginFooter({ className }) {
    return <p className={className + " " + "text-center text-muted small pt-4 lh-lg"}>
        info@turboleads.nl &nbsp; | &nbsp; 085 123 45 56
        <br />
        &copy; 2024 TurboLeads - sponsored by turbotheorie.nl
    </p>
}